import { render, staticRenderFns } from "./CheckinErrorPage.vue?vue&type=template&id=1961fb28"
import script from "./CheckinErrorPage.vue?vue&type=script&lang=js"
export * from "./CheckinErrorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports